import { render } from "./CardTomaFoto.vue?vue&type=template&id=15a86d9c&scoped=true"
import script from "./CardTomaFoto.vue?vue&type=script&lang=js"
export * from "./CardTomaFoto.vue?vue&type=script&lang=js"

import "./CardTomaFoto.vue?vue&type=style&index=0&id=15a86d9c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15a86d9c"]])

export default __exports__